// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  config: {
    apiKey: 'AIzaSyCaoCrDNK4Lo9ZCAJJZ6NQiaM2687nT5gc',
    authDomain: 'personaleforening-e0e21.firebaseapp.com',
    databaseURL: 'https://personaleforening-e0e21.firebaseio.com',
    projectId: 'personaleforening-e0e21',
    storageBucket: '',
    messagingSenderId: '507666740629'
  }
};


/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
